import { getInnerStyles } from '../styled/utils';
import styledCache from './styledCache';
export default styledCache(getInnerStyles);
//# sourceMappingURL=getStyledAvatar.js.map